import { TemplateAttributeType } from '../model/template-attribute-type.enum';
import { TemplateAttribute } from '../model/template-attribute';
import { Document } from '../model/document';
import { Validators, UntypedFormControl, ValidatorFn } from '@angular/forms';
import { Injectable } from '@angular/core';
import { TemplateAttributeMode } from '../model/template-attribute-mode.enum';

/**
 * Responsible to transform our template in a FormGroup.
 */
@Injectable({
  providedIn: 'root'
})
export class DocumentFormBuilderService {

  constructor() { }

  public createFormControls(document: Document): any {
    const group: any = {};
    if (document.template != null) {
      document.template.areas.forEach(area => {

        if (area.choiceAttribute != null) {
          const value = this.valueForAttribute(document, area.choiceAttribute);
          const fc = new UntypedFormControl(value, []);
          group[area.choiceAttribute.key] = fc;
        }

        area.attributes.forEach(attr => {
          const value = this.valueForAttribute(document, attr);
          const validators = this.getValidators(attr);
          const fc = new UntypedFormControl(value, validators);
          if (attr.mode === TemplateAttributeMode.DISABLED && (
            TemplateAttributeType.STRING !== attr.type &&
            TemplateAttributeType.TEXT !== attr.type &&
            TemplateAttributeType.NUMBER !== attr.type)) {
            // Achtung! controls im status disabled liefern keine werte zum Speichern!
            // Späterer zugriff muss über Form.getRawValues() erfolgen!
            fc.disable();
          }
          group[attr.key] = fc;
        });
      });
    }

    // initiale Selektion, falls noch nichts gesetzt wurde
    this.initializeChoiceSelection(document, group);

    // Choice mit Werten der FormControls synchronisieren
    this.synchronizeChoiceWithFormControls(document, group);

    return group;
  }

  private synchronizeChoiceWithFormControls(document: Document, group: any) {
    for (const templateArea of document.template.areas) {
      if (templateArea.choiceAttribute != null) {
        const ctrl = group[templateArea.choiceAttribute.key];
        if (ctrl != null) {
          // wenn choice aktiv
          if (ctrl.value === true) {
            templateArea.choiceAttribute.choiceSelected = true;
          } else {
            // wenn choice inatkiv, dann die zugehörigen FormCOntrols auf disabled setzen um Validierung zu deaktivieren
            templateArea.choiceAttribute.choiceSelected = false;
            for (const childAttribute of templateArea.attributes) {
              if (childAttribute.mode !== TemplateAttributeMode.DISABLED) {
                const childCtrl = group[childAttribute.key];
                childCtrl.disable();
              }
            }
          }
        }
      }
    }
  }

  private initializeChoiceSelection(document: Document, group: any) {

    const selectionByChoice: any[] = [];

    // selektierte Choices suchen
    for (const templateArea of document.template.areas) {
      if (templateArea.choiceAttribute != null) {
        let selectedChoices = selectionByChoice[templateArea.choice];
        if (selectedChoices == null) {
          selectedChoices = new Array<TemplateAttribute>();
          selectionByChoice[templateArea.choice] = selectedChoices;
        }
        if (templateArea.choiceAttribute.choiceSelected) {
          selectedChoices.push(templateArea.choiceAttribute);
        }
      }
    }

    for (const choice of Object.keys(selectionByChoice)) {
      // Wenn es keine Selektion zu einer Choice gibt
      if (selectionByChoice[choice].length === 0) {
        const areasOfChoice = document.template.areas.filter(a => a.choiceAttribute != null && a.choice === choice);
        // Dann selektiere die erste Area der Choice
        if (areasOfChoice != null && areasOfChoice.length > 0) {
          const toSelect = areasOfChoice[0];
          // ChoiceAttribut selektieren
          toSelect.choiceAttribute.choiceSelected = true;
          // und mit zugehörigen FormControl synchronisieren
          group[toSelect.choiceAttribute.key].setValue(true);
        }
      }
    }
  }

  private getValidators(attribute: TemplateAttribute): ValidatorFn[] {
    const validators = new Array<ValidatorFn>();
    if (attribute.required) {
      if (attribute.type === TemplateAttributeType.BOOLEAN_MANDATORY) {
        validators.push(required);
        //static required(control: AbstractControl): ValidationErrors | null;
      } else {
        validators.push(Validators.required);
      }
    }

    if (attribute.type === TemplateAttributeType.NUMBER) {
      validators.push(Validators.pattern('[a-zA-Z0-9,\.]*'));
    }
    return validators;
  }

  private valueForAttribute(document: Document, attribute: TemplateAttribute): any {
    if (document == null || document.values == null) {
      return '';
    }
    const result = document.values.filter(v => v.key === attribute.key);
    if (result.length > 0) {
      // BOOLEAN conversion
      if (attribute.type === TemplateAttributeType.BOOLEAN) {
        return result[0].value == 'true';
      }
      if (attribute.type === TemplateAttributeType.PHOTO) {
        return result[0].value;
      }
      return result[0].value;
    } else {
      return attribute.defaultValue;
    }
  }

}

function required(c: UntypedFormControl) {
  if (c.value == null || c.value === 'undefined') {
    return  {
      validateEmail: {
        valid: false
      }
    };
  }
  return null;
};
